// fuseOptions with decent balance of fuzzy search
const FUSE_OPTIONS = {
  shouldSort: true,
  includeScore: true,
  // perhaps can compute average length of all questions,
  // use 1/2 of the average as the location,
  // then (say threshold is 0.3) set distance = location * threshold?
  // such that exact terms can be searched?
  threshold: 0.44,
  location: 16,
  distance: 80,
  maxPatternLength: 64,
  minMatchCharLength: 2,
  keys: [
    'title',
    'synonyms',
  ],
}

export default FUSE_OPTIONS



// WEBPACK FOOTER //
// ./src/InteractionFolder/fuseOptions.js